module.exports = __webpack_public_path__ + "img/126.2078bd4.jpg";